export enum PermissionMessages {
  linkContractToUserText = "permission.linkContractToUserText",
  linkContractsSelectedText = "permission.linkContractsSelectedText",
  permissionsForText = "permission.permissionsForText",
  searchContractOrConstructionText = "permission.searchContractOrConstructionText"
}

export interface TranslationPermissionMessages {
  [PermissionMessages.linkContractToUserText]: string;
  [PermissionMessages.linkContractsSelectedText]: string;
  [PermissionMessages.permissionsForText]: string;
  [PermissionMessages.searchContractOrConstructionText]: string;
}
